import { styleClassNames } from '@chocolate-soup-inc/cs-frontend-components';
import clsx from 'clsx';
import { Outlet, useOutletContext } from 'react-router-dom';
import Header from './Header';
import styles from './Layout.module.scss';
import { Sidebar } from './Sidebar';

const Layout = () => {
  return (
    <div className={styleClassNames.appLayout}>
      <div className={styles.header}>
        <Header />
      </div>
      <div className={styles.sidebar}>
        <Sidebar />
      </div>
      <div className={clsx(styles.content)}>
        <Outlet
          context={{
            className: styles.contentOutlet,
            fullGridClassName: styles.fullGrid,
            gridContainerClassName: styles.gridContainer,
            titleClassName: styles.titleOutlet
          }}
        />
      </div>
    </div>
  );
};

export const useLayoutContext = () => {
  return useOutletContext<{
    className: string;
    fullGridClassName: string;
    gridContainerClassName: string;
    titleClassName: string;
  }>();
};

export default Layout;
